import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  formContainer: {
    flex: 1,
  },
  row: {
    padding: '24px 0',
  },
  rowemail: { padding: '0 0 24px 0' },
  rowbody: {
    padding: '0 0 24px 0',
  },
  chipcolor: {
    height: 'auto',
    overflowY: 'auto',
    '& .MuiChip-outlined': {
      backgroundColor: '#e0e0e0',
    },
    '& .MuiFormControl-fullWidth': {
      width: '99%',
    },
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  block: {
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  btnrow: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  btn1: {
    marginRight: '12px',
    padding: '12px 0',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '& .MuiInputBase-input': {
      padding: ' 0',
      color: 'white',
    },
  },
  btn2: {
    // marginTop: theme.spacing(1),
    marginLeft: '12px',
    padding: '12px 0',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '& .MuiInputBase-input': {
      padding: ' 0',
      color: 'white',
    },
  },
  bottomBtn: {
    height: '118px',
  },
  bottomBtn1: {
    height: '91px',
  },
  emailHeader: {
    background: '#363473',
    height: '63px',
    alignItems: 'center',
    marginTop: '22px',
    padding: '0 12px',
  },
  labels: {
    color: '#363473',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '160%',
    padding: '12px 0 0 40px',
  },
  details: {
    padding: '16px 0 0 40px',
    color: 'rgba(0, 0, 0, 0.64)',
  },
  btndetails: {
    color: 'rgba(0, 0, 0, 0.64)',
  },
  emailLink: {
    color: '#5081ff',
  },
  emailbtn: {
    borderBottom: '1px solid',
    padding: '0 0 24px 0',
    margin: '0 40px 0 40px',
    color: 'rgba(205, 218, 241, 1)',
  },
  system: {
    fontSize: '14px',
    padding: '24px 0 0 40px',
  },
  thanks: {
    '& .MuiInputBase-input': {
      fontWeight: 600,
      fontSize: '20px',
    },
  },
  admin: {
    '& .MuiInputBase-input': {
      color: 'rgba(0, 0, 0, 0.64)',
    },
  },
  callicon: {
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '8px 7px',
    borderRadius: '4px',
    '& .MuiSvgIcon-root ': {
      color: 'white',
      height: '18px',
      widthh: '18px',
    },
  },
  footerText: {
    color: 'white',
    marginLeft: '8px',
  },
}));
